
import {useEffect, useRef, useState} from "react";
import {toast} from "react-toastify";

// 外部向iframe内部传数据
export function sendMessage(iframeDom: any, cmd: string, data: any) {
	if (iframeDom) {
		iframeDom.postMessage(
			{
				cmd: cmd,
				params: data,
			},
			'*',
		);
	}
}

/**
 * icon图标库
 */
export function iconsArray() {
	return ['AcUnit','AccessAlarm','AccessAlarms','AccessTime','AccessTimeFilled','Accessibility','AccessibilityNew','Accessible','AccessibleForward','AccountBalance','AccountBalanceWallet','AccountBox','AccountCircle','AccountTree','AdUnits','Adb','Add','AddAPhoto','AddAlarm','AddAlert','AddBox','AddBusiness','AddChart','AddCircle','AddCircleOutline','AddComment','AddIcCall','AddLink','AddLocation','AddLocationAlt','AddModerator','AddPhotoAlternate','AddReaction','AddRoad','AddShoppingCart','AddTask','AddToDrive','AddToHomeScreen','AddToPhotos','AddToQueue','Adjust','AdminPanelSettings','AdsClick','Agriculture','Air','AirlineSeatFlat','AirlineSeatFlatAngled','AirlineSeatIndividualSuite','AirlineSeatLegroomExtra','AirlineSeatLegroomNormal','AirlineSeatLegroomReduced','AirlineSeatReclineExtra','AirlineSeatReclineNormal','AirplaneTicket','AirplanemodeActive','AirplanemodeInactive','Airplay','AirportShuttle','Alarm','AlarmAdd','AlarmOff','AlarmOn','Album','AlignHorizontalCenter','AlignHorizontalLeft','AlignHorizontalRight','AlignVerticalBottom','AlignVerticalCenter','AlignVerticalTop','AllInbox','AllInclusive','AllOut','AltRoute','AlternateEmail','AmpStories','Analytics','Anchor','Android','Animation','Announcement','Aod','Apartment','Api','AppBlocking','AppRegistration','AppSettingsAlt','Approval','Apps','Architecture','Archive','AreaChart','ArrowBack','ArrowBackIos','ArrowBackIosNew','ArrowCircleDown','ArrowCircleUp','ArrowDownward','ArrowDropDown','ArrowDropDownCircle','ArrowDropUp','ArrowForward','ArrowForwardIos','ArrowLeft','ArrowRight','ArrowRightAlt','ArrowUpward','ArtTrack','Article','AspectRatio','Assessment','Assignment','AssignmentInd','AssignmentLate','AssignmentReturn','AssignmentReturned','AssignmentTurnedIn','Assistant','AssistantDirection','AssistantPhoto','Atm','AttachEmail','AttachFile','AttachMoney','Attachment','Attractions','Attribution','Audiotrack','AutoAwesome','AutoAwesomeMosaic','AutoAwesomeMotion','AutoDelete','AutoFixHigh','AutoFixNormal','AutoFixOff','AutoGraph','AutoStories','AutofpsSelect','Autorenew','AvTimer','BabyChangingStation','BackHand','Backpack','Backspace','Backup','BackupTable','Badge','BakeryDining','Balcony','Ballot','BarChart','BatchPrediction','Bathroom','Bathtub','Battery20','Battery30','Battery50','Battery60','Battery80','Battery90','BatteryAlert','BatteryCharging20','BatteryCharging30','BatteryCharging50','BatteryCharging60','BatteryCharging80','BatteryCharging90','BatteryChargingFull','BatteryFull','BatterySaver','BatteryStd','BatteryUnknown','BeachAccess','Bed','BedroomBaby','BedroomChild','BedroomParent','Bedtime','Beenhere','Bento','BikeScooter','Biotech','Blender','Block','Bloodtype','Bluetooth','BluetoothAudio','BluetoothConnected','BluetoothDisabled','BluetoothDrive','BluetoothSearching','BlurCircular','BlurLinear','BlurOff','BlurOn','Bolt','Book','BookOnline','Bookmark','BookmarkAdd','BookmarkAdded','BookmarkBorder','BookmarkRemove','Bookmarks','BorderAll','BorderBottom','BorderClear','BorderColor','BorderHorizontal','BorderInner','BorderLeft','BorderOuter','BorderRight','BorderStyle','BorderTop','BorderVertical','BrandingWatermark','BreakfastDining','Brightness1','Brightness2','Brightness3','Brightness4','Brightness5','Brightness6','Brightness7','BrightnessAuto','BrightnessHigh','BrightnessLow','BrightnessMedium','BrokenImage','BrowserNotSupported','BrunchDining','Brush','BubbleChart','BugReport','Build','BuildCircle','Bungalow','BurstMode','BusAlert','Business','BusinessCenter','Cabin','Cable','Cached','Cake','Calculate','CalendarToday','CalendarViewDay','CalendarViewMonth','CalendarViewWeek','Call','CallEnd','CallMade','CallMerge','CallMissed','CallMissedOutgoing','CallReceived','CallSplit','CallToAction','Camera','CameraAlt','CameraEnhance','CameraFront','CameraIndoor','CameraOutdoor','CameraRear','CameraRoll','Cameraswitch','Campaign','Cancel','CancelPresentation','CancelScheduleSend','CarRental','CarRepair','CardGiftcard','CardMembership','CardTravel','Carpenter','Cases','Casino','Cast','CastConnected','CastForEducation','CatchingPokemon','Category','Celebration','CellWifi','CenterFocusStrong','CenterFocusWeak','Chair','ChairAlt','Chalet','ChangeCircle','ChangeHistory','ChargingStation','Chat','ChatBubble','ChatBubbleOutline','Check','CheckBox','CheckBoxOutlineBlank','CheckCircle','CheckCircleOutline','Checklist','ChecklistRtl','Checkroom','ChevronLeft','ChevronRight','ChildCare','ChildFriendly','ChromeReaderMode','Circle','CircleNotifications','Class','CleanHands','CleaningServices','Clear','ClearAll','Close','CloseFullscreen','ClosedCaption','ClosedCaptionDisabled','ClosedCaptionOff','Cloud','CloudCircle','CloudDone','CloudDownload','CloudOff','CloudQueue','CloudUpload','Code','CodeOff','Coffee','CoffeeMaker','Collections','CollectionsBookmark','ColorLens','Colorize','Comment','CommentBank','Commute','Compare','CompareArrows','CompassCalibration','Compost','Compress','Computer','ConfirmationNumber','ConnectWithoutContact','ConnectedTv','Construction','ContactMail','ContactPage','ContactPhone','ContactSupport','Contactless','Contacts','ContentCopy','ContentCut','ContentPaste','ContentPasteOff','ControlCamera','ControlPoint','ControlPointDuplicate','CopyAll','Copyright','Coronavirus','CorporateFare','Cottage','Countertops','Create','CreateNewFolder','CreditCard','CreditCardOff','CreditScore','Crib','Crop','Crop169','Crop32','Crop54','Crop75','CropDin','CropFree','CropLandscape','CropOriginal','CropPortrait','CropRotate','CropSquare','CrueltyFree','Dangerous','DarkMode','Dashboard','DashboardCustomize','DataExploration','DataSaverOff','DataSaverOn','DataUsage','DateRange','Deck','Dehaze','Delete','DeleteForever','DeleteOutline','DeleteSweep','DeliveryDining','DepartureBoard','Description','DesignServices','DesktopAccessDisabled','DesktopMac','DesktopWindows','Details','DeveloperBoard','DeveloperBoardOff','DeveloperMode','DeviceHub','DeviceThermostat','DeviceUnknown','Devices','DevicesOther','DialerSip','Dialpad','Dining','DinnerDining','Directions','DirectionsBike','DirectionsBoat','DirectionsBoatFilled','DirectionsBus','DirectionsBusFilled','DirectionsCar','DirectionsCarFilled','DirectionsOff','DirectionsRailway','DirectionsRailwayFilled','DirectionsRun','DirectionsSubway','DirectionsSubwayFilled','DirectionsTransit','DirectionsTransitFilled','DirectionsWalk','DirtyLens','DisabledByDefault','DisabledVisible','DiscFull','Dns','DoDisturb','DoDisturbAlt','DoDisturbOff','DoDisturbOn','DoNotDisturb','DoNotDisturbAlt','DoNotDisturbOff','DoNotDisturbOn','DoNotDisturbOnTotalSilence','DoNotStep','DoNotTouch','Dock','DocumentScanner','Domain','DomainDisabled','DomainVerification','Done','DoneAll','DoneOutline','DonutLarge','DonutSmall','DoorBack','DoorFront','DoorSliding','Doorbell','DoubleArrow','DownhillSkiing','Download','DownloadDone','DownloadForOffline','Downloading','Drafts','DragHandle','DragIndicator','Draw','DriveEta','DriveFileMove','DriveFileMoveRtl','DriveFileRenameOutline','DriveFolderUpload','Dry','DryCleaning','Duo','Dvr','DynamicFeed','DynamicForm','EMobiledata','Earbuds','EarbudsBattery','East','Eco','EdgesensorHigh','EdgesensorLow','Edit','EditAttributes','EditCalendar','EditLocation','EditLocationAlt','EditNote','EditNotifications','EditOff','EditRoad','Eject','Elderly','ElectricBike','ElectricCar','ElectricMoped','ElectricRickshaw','ElectricScooter','ElectricalServices','Elevator','Email','Emergency','EmojiEmotions','EmojiEvents','EmojiFlags','EmojiFoodBeverage','EmojiNature','EmojiObjects','EmojiPeople','EmojiSymbols','EmojiTransportation','Engineering','EnhancedEncryption','Equalizer','Error','ErrorOutline','Escalator','EscalatorWarning','Euro','EuroSymbol','EvStation','Event','EventAvailable','EventBusy','EventNote','EventSeat','ExitToApp','Expand','ExpandLess','ExpandMore','Explicit','Explore','ExploreOff','Exposure','ExposureNeg1','ExposureNeg2','ExposurePlus1','ExposurePlus2','ExposureZero','Extension','ExtensionOff','Face','FaceRetouchingNatural','FaceRetouchingOff','Facebook','FactCheck','FamilyRestroom','FastForward','FastRewind','Fastfood','Favorite','FavoriteBorder','FeaturedPlayList','FeaturedVideo','Feed','Feedback','Female','Fence','Festival','FiberDvr','FiberManualRecord','FiberNew','FiberPin','FiberSmartRecord','FileCopy','FileDownload','FileDownloadDone','FileDownloadOff','FilePresent','FileUpload','Filter','Filter1','Filter2','Filter3','Filter4','Filter5','Filter6','Filter7','Filter8','Filter9','Filter9Plus','FilterAlt','FilterBAndW','FilterCenterFocus','FilterDrama','FilterFrames','FilterHdr','FilterList','FilterNone','FilterTiltShift','FilterVintage','FindInPage','FindReplace','Fingerprint','FireExtinguisher','Fireplace','FirstPage','FitScreen','FitnessCenter','Flag','Flaky','Flare','FlashAuto','FlashOff','FlashOn','FlashlightOff','FlashlightOn','Flatware','Flight','FlightLand','FlightTakeoff','Flip','FlipCameraAndroid','FlipCameraIos','FlipToBack','FlipToFront','Flourescent','FlutterDash','FmdBad','FmdGood','Folder','FolderOpen','FolderShared','FolderSpecial','FollowTheSigns','FontDownload','FontDownloadOff','FoodBank','FormatAlignCenter','FormatAlignJustify','FormatAlignLeft','FormatAlignRight','FormatBold','FormatClear','FormatColorFill','FormatColorReset','FormatColorText','FormatIndentDecrease','FormatIndentIncrease','FormatItalic','FormatLineSpacing','FormatListBulleted','FormatListNumbered','FormatListNumberedRtl','FormatPaint','FormatQuote','FormatShapes','FormatSize','FormatStrikethrough','FormatTextdirectionLToR','FormatTextdirectionRToL','FormatUnderlined','Forum','Forward','Forward10','Forward30','Forward5','ForwardToInbox','Foundation','FreeBreakfast','FreeCancellation','FrontHand','Fullscreen','FullscreenExit','Functions','GMobiledata','GTranslate','Gamepad','Games','Garage','Gavel','GeneratingTokens','Gesture','GetApp','Gif','Gite','GolfCourse','GppBad','GppGood','GppMaybe','GpsFixed','GpsNotFixed','GpsOff','Grade','Gradient','Grading','Grain','GraphicEq','Grass','Grid3X3','Grid4X4','GridGoldenratio','GridOff','GridOn','GridView','Group','GroupAdd','GroupOff','GroupWork','Groups','HMobiledata','HPlusMobiledata','Hail','Handyman','Hardware','Hd','HdrAuto','HdrAutoSelect','HdrEnhancedSelect','HdrOff','HdrOffSelect','HdrOn','HdrOnSelect','HdrPlus','HdrStrong','HdrWeak','Headphones','HeadphonesBattery','Headset','HeadsetMic','HeadsetOff','Healing','HealthAndSafety','Hearing','HearingDisabled','Height','Help','HelpCenter','HelpOutline','Hevc','HideImage','HideSource','HighQuality','Highlight','HighlightAlt','HighlightOff','Hiking','History','HistoryEdu','HistoryToggleOff','HolidayVillage','Home','HomeMax','HomeMini','HomeRepairService','HomeWork','HorizontalDistribute','HorizontalRule','HorizontalSplit','HotTub','Hotel','HotelClass','HourglassBottom','HourglassDisabled','HourglassEmpty','HourglassFull','HourglassTop','House','HouseSiding','Houseboat','HowToReg','HowToVote','Http','Https','Hvac','IceSkating','Icecream','Image','ImageAspectRatio','ImageNotSupported','ImageSearch','ImagesearchRoller','ImportContacts','ImportExport','ImportantDevices','Inbox','IncompleteCircle','IndeterminateCheckBox','Info','InfoOutline','Input','InsertChart','InsertComment','InsertDriveFile','InsertEmoticon','InsertInvitation','InsertLink','InsertPhoto','Insights','IntegrationInstructions','Inventory','Inventory2','InvertColors','InvertColorsOff','IosShare','Iron','Iso','Kayaking','Keyboard','KeyboardAlt','KeyboardArrowDown','KeyboardArrowLeft','KeyboardArrowRight','KeyboardArrowUp','KeyboardBackspace','KeyboardCapslock','KeyboardHide','KeyboardReturn','KeyboardTab','KeyboardVoice','KingBed','Kitchen','Kitesurfing','Label','LabelImportant','LabelOff','Landscape','Language','Laptop','LaptopChromebook','LaptopMac','LaptopWindows','LastPage','Launch','Layers','LayersClear','Leaderboard','LeakAdd','LeakRemove','LegendToggle','Lens','LensBlur','LibraryAdd','LibraryAddCheck','LibraryBooks','LibraryMusic','Light','LightMode','Lightbulb','LineStyle','LineWeight','LinearScale','Link','LinkOff','LinkedCamera','Liquor','List','ListAlt','LiveHelp','LiveTv','Living','LocalActivity','LocalAirport','LocalAtm','LocalBar','LocalCafe','LocalCarWash','LocalConvenienceStore','LocalDining','LocalDrink','LocalFireDepartment','LocalFlorist','LocalGasStation','LocalGroceryStore','LocalHospital','LocalHotel','LocalLaundryService','LocalLibrary','LocalMall','LocalMovies','LocalOffer','LocalParking','LocalPharmacy','LocalPhone','LocalPizza','LocalPlay','LocalPolice','LocalPostOffice','LocalPrintshop','LocalSee','LocalShipping','LocalTaxi','LocationCity','LocationDisabled','LocationOff','LocationOn','LocationSearching','Lock','LockClock','LockOpen','Login','Logout','Looks','Looks3','Looks4','Looks5','Looks6','LooksOne','LooksTwo','Loop','Loupe','LowPriority','Loyalty','LteMobiledata','LtePlusMobiledata','Luggage','LunchDining','Mail','MailOutline','Male','ManageAccounts','ManageSearch','Map','MapsHomeWork','MapsUgc','Margin','MarkAsUnread','MarkChatRead','MarkChatUnread','MarkEmailRead','MarkEmailUnread','Markunread','MarkunreadMailbox','Masks','Maximize','MediaBluetoothOff','MediaBluetoothOn','Mediation','MedicalServices','Medication','MeetingRoom','Memory','Menu','MenuBook','MenuOpen','MergeType','Message','Mic','MicExternalOff','MicExternalOn','MicNone','MicOff','Microwave','MilitaryTech','Minimize','MiscellaneousServices','MissedVideoCall','Mms','MobileFriendly','MobileOff','MobileScreenShare','Mode','ModeComment','ModeEdit','ModeEditOutline','ModelTraining','MonetizationOn','Money','MoneyOff','MoneyOffCsred','Monitor','MonochromePhotos','Mood','MoodBad','Moped','More','MoreHoriz','MoreTime','MoreVert','MotionPhotosAuto','MotionPhotosOff','MotionPhotosOn','MotionPhotosPause','MotionPhotosPaused','Mouse','MoveToInbox','Movie','MovieCreation','MovieFilter','Moving','Mp','MultilineChart','MultipleStop','Museum','MusicNote','MusicOff','MusicVideo','MyLocation','Nat','Nature','NaturePeople','NavigateBefore','NavigateNext','Navigation','NearMe','NearMeDisabled','NetworkCheck','NetworkLocked','NewLabel','NewReleases','NextPlan','NextWeek','NightShelter','Nightlife','NightlightRound','NightsStay','NoAccounts','NoBackpack','NoCell','NoDrinks','NoEncryption','NoEncryptionGmailerrorred','NoFlash','NoFood','NoLuggage','NoMeals','NoMeetingRoom','NoPhotography','NoSim','NoStroller','NoTransfer','NordicWalking','North','NorthEast','NorthWest','NotAccessible','NotInterested','NotListedLocation','NotStarted','Note','NoteAdd','Notes','NotificationAdd','NotificationImportant','Notifications','NotificationsActive','NotificationsNone','NotificationsOff','NotificationsPaused','OfflineBolt','OfflinePin','OfflineShare','OndemandVideo','OnlinePrediction','Opacity','OpenInBrowser','OpenInFull','OpenInNew','OpenInNewOff','OpenWith','OtherHouses','Outbond','Outbound','Outbox','OutdoorGrill','Outlet','Padding','Pages','Pageview','Paid','Palette','PanTool','Panorama','PanoramaFishEye','PanoramaHorizontal','PanoramaHorizontalSelect','PanoramaPhotosphere','PanoramaPhotosphereSelect','PanoramaVertical','PanoramaVerticalSelect','PanoramaWideAngle','PanoramaWideAngleSelect','Paragliding','Park','PartyMode','Pause','PauseCircle','PauseCircleFilled','PauseCircleOutline','PausePresentation','Payment','Payments','PedalBike','Pending','PendingActions','People','PeopleAlt','PeopleOutline','PermCameraMic','PermContactCalendar','PermDataSetting','PermDeviceInformation','PermIdentity','PermMedia','PermPhoneMsg','PermScanWifi','Person','PersonAdd','PersonAddAlt','PersonAddAlt1','PersonAddDisabled','PersonOff','PersonOutline','PersonPin','PersonPinCircle','PersonRemove','PersonRemoveAlt1','PersonSearch','PersonalInjury','PersonalVideo','PestControl','PestControlRodent','Pets','Phone','PhoneAndroid','PhoneBluetoothSpeaker','PhoneCallback','PhoneDisabled','PhoneEnabled','PhoneForwarded','PhoneInTalk','PhoneIphone','PhoneLocked','PhoneMissed','PhonePaused','Phonelink','PhonelinkErase','PhonelinkLock','PhonelinkOff','PhonelinkRing','PhonelinkSetup','Photo','PhotoAlbum','PhotoCamera','PhotoCameraBack','PhotoCameraFront','PhotoFilter','PhotoLibrary','PhotoSizeSelectActual','PhotoSizeSelectLarge','PhotoSizeSelectSmall','Piano','PianoOff','PictureAsPdf','PictureInPicture','PictureInPictureAlt','PieChart','PieChartOutline','PinDrop','PinEnd','PinInvoke','PivotTableChart','Place','Plagiarism','PlayArrow','PlayCircle','PlayCircleFilled','PlayCircleOutline','PlayDisabled','PlayForWork','PlaylistAdd','PlaylistAddCheck','PlaylistPlay','Plumbing','PlusOne','Podcasts','PointOfSale','Policy','Poll','Polymer','Pool','PortableWifiOff','Portrait','PostAdd','Power','PowerInput','PowerOff','PowerSettingsNew','PrecisionManufacturing','PregnantWoman','PresentToAll','Preview','Print','PrintDisabled','PriorityHigh','PrivacyTip','PrivateConnectivity','ProductionQuantityLimits','Psychology','Public','PublicOff','Publish','PublishedWithChanges','PushPin','QrCode','QrCode2','QrCodeScanner','QueryBuilder','QueryStats','QuestionAnswer','Queue','QueueMusic','QueuePlayNext','Quickreply','Radio','RadioButtonChecked','RadioButtonUnchecked','RailwayAlert','RamenDining','RateReview','RawOff','RawOn','ReadMore','RealEstateAgent','Receipt','ReceiptLong','RecentActors','Recommend','RecordVoiceOver','Recycling','Redeem','Redo','ReduceCapacity','Refresh','Remove','RemoveCircle','RemoveCircleOutline','RemoveDone','RemoveFromQueue','RemoveModerator','RemoveRedEye','RemoveShoppingCart','Reorder','Repeat','RepeatOn','RepeatOne','RepeatOneOn','Replay','Replay10','Replay30','Replay5','ReplayCircleFilled','Reply','ReplyAll','Report','ReportGmailerrorred','ReportOff','ReportProblem','RequestPage','RequestQuote','Restaurant','RestaurantMenu','Restore','RestoreFromTrash','RestorePage','RiceBowl','RingVolume','Roofing','Room','RoomPreferences','RoomService','Rotate90DegreesCcw','RotateLeft','RotateRight','RoundedCorner','Router','Rowing','RssFeed','Rtt','Rule','RuleFolder','RunCircle','RunningWithErrors','RvHookup','SafetyDivider','Sailing','Sanitizer','Satellite','Save','SaveAlt','SavedSearch','Savings','Scanner','ScatterPlot','Schedule','ScheduleSend','Schema','School','Science','Score','ScreenShare','Sd','SdCard','SdCardAlert','Search','SearchOff','Security','Segment','SelectAll','SelfImprovement','Send','SendAndArchive','SensorDoor','SensorWindow','Sensors','SensorsOff','SentimentDissatisfied','SentimentNeutral','SentimentSatisfied','SentimentSatisfiedAlt','SentimentVeryDissatisfied','SentimentVerySatisfied','SetMeal','Settings','SettingsAccessibility','SettingsApplications','SettingsBackupRestore','SettingsBluetooth','SettingsBrightness','SettingsCell','SettingsEthernet','SettingsInputAntenna','SettingsInputComponent','SettingsInputComposite','SettingsInputHdmi','SettingsInputSvideo','SettingsOverscan','SettingsPhone','SettingsPower','SettingsRemote','SettingsVoice','Share','Shield','Shop','Shop2','ShopTwo','ShoppingBag','ShoppingBasket','ShoppingCart','ShortText','ShowChart','Shower','Shuffle','ShuffleOn','ShutterSpeed','Sick','SignalCellular0Bar','SignalCellular1Bar','SignalCellular2Bar','SignalCellular3Bar','SignalCellular4Bar','SignalCellularAlt','SignalCellularConnectedNoInternet0Bar','SignalCellularConnectedNoInternet1Bar','SignalCellularConnectedNoInternet2Bar','SignalCellularConnectedNoInternet3Bar','SignalCellularConnectedNoInternet4Bar','SignalCellularNoSim','SignalCellularNodata','SignalCellularNull','SignalCellularOff','SignalWifi0Bar','SignalWifi1Bar','SignalWifi1BarLock','SignalWifi2Bar','SignalWifi2BarLock','SignalWifi3Bar','SignalWifi3BarLock','SignalWifi4Bar','SignalWifi4BarLock','SignalWifiBad','SignalWifiConnectedNoInternet0','SignalWifiConnectedNoInternet1','SignalWifiConnectedNoInternet2','SignalWifiConnectedNoInternet3','SignalWifiConnectedNoInternet4','SignalWifiOff','SignalWifiStatusbar1Bar','SignalWifiStatusbar2Bar','SignalWifiStatusbar3Bar','SignalWifiStatusbar4Bar','SignalWifiStatusbarConnectedNoInternet','SignalWifiStatusbarConnectedNoInternet1','SignalWifiStatusbarConnectedNoInternet2','SignalWifiStatusbarConnectedNoInternet3','SignalWifiStatusbarConnectedNoInternet4','SignalWifiStatusbarNotConnected','SignalWifiStatusbarNull','SimCard','SimCardAlert','SimCardDownload','SingleBed','Sip','Skateboarding','SkipNext','SkipPrevious','Sledding','Slideshow','SlowMotionVideo','SmartButton','SmartDisplay','SmartScreen','SmartToy','Smartphone','SmokeFree','SmokingRooms','Sms','SmsFailed','SnippetFolder','Snooze','Snowboarding','Snowmobile','Snowshoeing','Soap','SocialDistance','Sort','SortByAlpha','Source','South','SouthEast','SouthWest','Spa','SpaceBar','SpaceDashboard','Speaker','SpeakerGroup','SpeakerNotes','SpeakerNotesOff','SpeakerPhone','Speed','Spellcheck','Splitscreen','Sports','SportsBar','SportsBaseball','SportsBasketball','SportsCricket','SportsEsports','SportsFootball','SportsGolf','SportsHandball','SportsHockey','SportsKabaddi','SportsMma','SportsMotorsports','SportsRugby','SportsScore','SportsSoccer','SportsTennis','SportsVolleyball','SquareFoot','StackedBarChart','StackedLineChart','Stairs','Star','StarBorder','StarBorderPurple500','StarHalf','StarOutline','StarPurple500','StarRate','Stars','StayCurrentLandscape','StayCurrentPortrait','StayPrimaryLandscape','StayPrimaryPortrait','StickyNote2','Stop','StopCircle','StopScreenShare','Storage','Store','StoreMallDirectory','Storefront','Storm','Straighten','Stream','Streetview','StrikethroughS','Stroller','Style','SubdirectoryArrowLeft','SubdirectoryArrowRight','Subject','Subscript','Subscriptions','Subtitles','SubtitlesOff','Subway','Summarize','Superscript','SupervisedUserCircle','SupervisorAccount','Support','SupportAgent','Surfing','SurroundSound','Svg10K','Svg10Mp','Svg11Mp','Svg12Mp','Svg13Mp','Svg14Mp','Svg15Mp','Svg16Mp','Svg17Mp','Svg18Mp','Svg19Mp','Svg1K','Svg1KPlus','Svg1XMobiledata','Svg20Mp','Svg21Mp','Svg22Mp','Svg23Mp','Svg24Mp','Svg2K','Svg2KPlus','Svg2Mp','Svg30Fps','Svg30FpsSelect','Svg360','Svg3DRotation','Svg3GMobiledata','Svg3K','Svg3KPlus','Svg3Mp','Svg3P','Svg4GMobiledata','Svg4GPlusMobiledata','Svg4K','Svg4KPlus','Svg4Mp','Svg5G','Svg5K','Svg5KPlus','Svg5Mp','Svg60Fps','Svg60FpsSelect','Svg6FtApart','Svg6K','Svg6KPlus','Svg6Mp','Svg7K','Svg7KPlus','Svg7Mp','Svg8K','Svg8KPlus','Svg8Mp','Svg9K','Svg9KPlus','Svg9Mp','SwapCalls','SwapHoriz','SwapHorizontalCircle','SwapVert','SwapVerticalCircle','Swipe','SwitchAccount','SwitchCamera','SwitchLeft','SwitchRight','SwitchVideo','Sync','SyncAlt','SyncDisabled','SyncProblem','SystemSecurityUpdate','SystemSecurityUpdateGood','SystemSecurityUpdateWarning','SystemUpdate','SystemUpdateAlt','Tab','TabUnselected','TableChart','TableRows','TableView','Tablet','TabletAndroid','TabletMac','Tag','TagFaces','TakeoutDining','TapAndPlay','Tapas','Task','TaskAlt','TaxiAlert','Terrain','TextFields','TextFormat','TextRotateUp','TextRotateVertical','TextRotationAngledown','TextRotationAngleup','TextRotationDown','TextRotationNone','TextSnippet','Textsms','Texture','TheaterComedy','Theaters','Thermostat','ThermostatAuto','ThumbDown','ThumbDownAlt','ThumbDownOffAlt','ThumbUp','ThumbUpAlt','ThumbUpOffAlt','ThumbsUpDown','TimeToLeave','Timelapse','Timeline','Timer','Timer10','Timer10Select','Timer3','Timer3Select','TimerOff','TipsAndUpdates','Title','Toc','Today','ToggleOff','ToggleOn','Toll','Tonality','Topic','TouchApp','Tour','Toys','TrackChanges','Traffic','Train','Tram','TransferWithinAStation','Transform','Transgender','TransitEnterexit','Translate','TravelExplore','TrendingDown','TrendingFlat','TrendingUp','TripOrigin','Try','Tty','Tune','Tungsten','TurnedIn','TurnedInNot','Tv','TvOff','TwoWheeler','Umbrella','Unarchive','Undo','UnfoldLess','UnfoldMore','Unpublished','Unsubscribe','Upcoming','Update','UpdateDisabled','Upgrade','Upload','UploadFile','Usb','UsbOff','Verified','VerifiedUser','VerticalAlignBottom','VerticalAlignCenter','VerticalAlignTop','VerticalDistribute','VerticalSplit','Vibration','VideoCall','VideoCameraBack','VideoCameraFront','VideoLabel','VideoLibrary','VideoSettings','VideoStable','Videocam','VideocamOff','VideogameAsset','VideogameAssetOff','ViewAgenda','ViewArray','ViewCarousel','ViewColumn','ViewComfy','ViewCompact','ViewDay','ViewHeadline','ViewInAr','ViewList','ViewModule','ViewQuilt','ViewSidebar','ViewStream','ViewWeek','Vignette','Villa','Visibility','VisibilityOff','VoiceChat','VoiceOverOff','Voicemail','VolumeDown','VolumeMute','VolumeOff','VolumeUp','VolunteerActivism','VpnKey','VpnLock','Vrpano','Wallpaper','Warning','WarningAmber','Wash','Watch','WatchLater','Water','WaterDamage','WaterDrop','WaterfallChart','Waves','WavingHand','WbAuto','WbCloudy','WbIncandescent','WbIridescent','WbShade','WbSunny','WbTwilight','Wc','Web','WebAsset','WebAssetOff','Weekend','West','Whatshot','WheelchairPickup','WhereToVote','Widgets','Wifi','WifiCalling','WifiCalling1','WifiCalling2','WifiCalling3','WifiLock','WifiOff','WifiProtectedSetup','WifiTethering','WifiTetheringErrorRounded','WifiTetheringOff','Window','WineBar','Work','WorkOff','WorkOutline','Workspaces','WrapText','WrongLocation','Wysiwyg','Yard','YoutubeSearchedFor','ZoomIn','ZoomOut','ZoomOutMap'];
}
export function useWebSocketVideo(url: string) {
	const [webSocket, setWebSocket] = useState<WebSocket | null>(null);
	const [videoUrl, setVideoUrl] = useState<string>('');
	const videoUrlRef = useRef<string>('');


	useEffect(() => {
		// 创建 WebSocket 连接
		const ws = new WebSocket(url);

		// 保存 WebSocket 实例
		setWebSocket(ws);

		// 监听 WebSocket 连接状态
		ws.onopen = () => {
			console.log('WebSocket 已连接');
		};

		ws.onclose = (event) => {
			console.log('WebSocket 连接已关闭', event);

			// 重连
			setTimeout(() => {
				console.log('WebSocket 重连中...');
				setWebSocket(new WebSocket(url));
			}, 3000);
		};

		ws.onerror = (error) => {
			console.error('WebSocket 连接错误', error);
		};

		ws.onmessage = (event) => {
			// 接收并解析收到的消息
			const message = JSON.parse(event.data);

			// 若消息类型为视频流，则更新视频地址
			if (message.type === 'video') {
				const newVideoUrl = message.data;

				setVideoUrl(newVideoUrl);
				videoUrlRef.current = newVideoUrl;
			}
		};

		// 清除函数
		return () => {
			// 关闭 WebSocket 连接
			if (webSocket && webSocket.readyState === WebSocket.OPEN) {
				webSocket.close();
			}

			// 清除视频地址
			setVideoUrl('');
			videoUrlRef.current = '';
		};
	}, [ url ]);

	return videoUrl || videoUrlRef.current;
}

/**
 * 信发错误日志 常量
 */
export function mediaEventLogData(): any {
	return {
		oid: uuid2(32,16),
		model: 1,
		create_time: curTimeStamp(),
		status: 1
	}
}


// '提示', // String, HTML or Component
// 	'请输入用户账号！', // String, HTML or Component
// 	'danger' // 'default' || 'info' || 'warning' || 'success' || 'danger',
export function showNotification(
	title: string,
	message: string,
	type: string
) {
	let toastCode = null
	switch (type) {
		case "success":
			toastCode = toast.success
			break;
		case "warning":
			toastCode = toast.warning
			break;
		default:
			toastCode = toast.error
			break;
	}

	toastCode(
		message,
		{
			position: toast.POSITION.TOP_CENTER,
			hideProgressBar: true,
			theme: "colored",
		}
	);

	return false
}


/**
 * 异常提示
 * @param abnormalText
 * @param typeCode //
 * @constructor
 */

type NOTIFICATION_TYPE = 'success' | 'danger' | 'info' | 'default' | 'warning' | 'error';
export function abnormalPrompt(abnormalText: string, typeCode: NOTIFICATION_TYPE) {
	showNotification(
		'消息提示', // String, HTML or Component
		abnormalText, // String, HTML or Component
		typeCode,
	);

	return false;
}



/**
 * 无纸化错误日志 常量
 */
export function paperlessEventLogData(): any {
	return {
		oid: uuid2(32,16),
		model: 3,
		create_time: curTimeStamp(),
		status: 1
	}
}

/**
 * 安装
 */
export function installTypeInfo(key:number):any {
	let FieldValue = null;
	let installTypeData = [
		{
			value: 1,
			label: 'Android程序',
		},
		{
			value: 2,
			label: 'Windows程序',
		},
		{
			value: 3,
			label: '呼叫服务',
		},
		{
			value: 4,
			label: '桌牌',
		},
		{
			value: 5,
			label: '大屏程序',
		},
		{
			value: 6,
			label: '水牌',
		},
		{
			value: 7,
			label: 'Android会议显示终端',
		},
	];

	installTypeData.map((item: any) => {
		if (item.value === key) {
			FieldValue = item["label"];
		}
	});

	return FieldValue ?? '- - -';
}

/**
 * 随机生成动漫风格的昵称：
 */
export function generateAnimeNickname() {
	const adjectives = ["浪漫的", "勇敢的", "萌萌的", "狂野的", "神秘的", "无敌的", "小巧玲珑的", "可爱的", "超级的", "机智的"];
	const nouns = ["剑士", "魔法师", "武士", "忍者", "鬼怪", "海盗", "宝藏猎人", "战士", "英雄", "神仙"];
	const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
	const noun = nouns[Math.floor(Math.random() * nouns.length)];
	const number = Math.floor(Math.random() * 100);
	return `${adjective}${noun}${number}`;
}


/***
 * 文件下载
 * @param fileName
 * @param address
 */
export function downloadFile(fileName:string, address:string) {
	let x = new XMLHttpRequest();
	x.open("GET", address, true);
	x.responseType = 'blob';
	x.onload = function (e) {
		let a = document.createElement('a');
		a.href = window.URL.createObjectURL(x.response)
		a.download = fileName; //下载后的文件名
		a.click()
	}
	x.send();
}



/**
 * 数组排序
 * @param arr
 * @param key 需要排序的字段
 * @param order 排序
 */
export function sortByKey(arr:any,key:string,order:string){
	if (arr.length >= 1) {
		for(let i=0;i<arr.length;i++){
			for(let j=i+1;j<arr.length;j++){
				if(order=='desc'){
					if(parseFloat(arr[i][key])<=parseFloat(arr[j][key])){
						var min=arr[i];
						arr[i]=arr[j];
						arr[j]=min;
					}
				}else{
					if(parseFloat(arr[i][key])>=parseFloat(arr[j][key])){
						var max=arr[i];
						arr[i]=arr[j];
						arr[j]=max;
					}
				}
			}
		}
	}

	return arr;
}


export function funLayoutFileInfo(generateHtml:any ) {
	const dataCode = ['imgFile', 'videoFile', 'audioFile','pptFile', 'wordFile', 'pdfFile', 'settingImg']
	const attribute:any[] = [] // 节目文件
	const doc = new DOMParser().parseFromString(generateHtml, 'text/html').body.querySelectorAll('div')
	for (let i = 0; i < doc.length; i++) {
		const htmlDivElement = doc.item(i)
		for (const i of dataCode) {
			const image = htmlDivElement.getAttribute('data-' + i)

			if (inArrays(i,['pptFile', 'wordFile', 'pdfFile', 'webPath']) && image !== null) {
				let item = image.split(',')[0].slice(1)

				attribute.push(item.substring(0, item.lastIndexOf("/")))
			}else {
				if (image != null) {
					for (const item of image.split(',')) {
						attribute.push(item.substring(0, item.lastIndexOf(".")).slice(1))
					}
				}
			}
		}
	}
	return attribute
}


/**
 * 当前时间戳
 */
export function curTimeStamp() {
	return Number(new Date(Date.parse(new Date().toString()))) / 1000;
}

/**
 *
 * @param start
 * @param end
 */
export function range(start: number, end: number) {
	const result = [];
	for (let i = start; i < end; i++) {
		result.push(i);
	}
	return result;
};

/**
 * 随机生成#FFFFFF样式的颜色
 */
export function randomColor() {
	var col = "#";
	for (var i = 0; i < 8; i++) col+=parseInt(String(Math.random() * 16)).toString(16);
	return col;
}


// base64 图片预览
export function imagePreview(Base64:string) {
	const img:any = new window.Image();
	img.src = Base64;
	img.style.maxwidth = "100%";
	img.style.maxheight = "100%";

	const newWin:any = window.open('');
	newWin.document.body.style.background = '#000';
	newWin.document.body.style.textAlign = 'center';
	newWin.document.body.appendChild(img);
	newWin.document.title = '图片预览';
	newWin.document.close();
}


/**
 * 选择当前项 自动选择子项，
 * 返回选中的 id: any[]
 * @param array
 * @param id
 * @param field
 */
export function setSelectSubordinates(array: any, id: number, field: string) {
	let allResult: any = [];
	if (array) {
		for (let item of array) {
			if (Number(item.pid) === id) {
				if (item[field]) {
					let result: any[] = setSelectSubordinates(item[field], Number(item.value), field)

					allResult = allResult.concat(result);
				}

				allResult = allResult.concat([
					item.value,
					id
				]);
			}
		}
	}

	return allResult.filter((item: any, index: any) => allResult.indexOf(item) === index)
}


/**
 * 在这里，getSubtreeByKey 函数接收两个参数，一个是 JSON 数据数组，另一个是需要查找的 key 值。首先，我们使用 find 方法从数据数组中找到根节点，并将其传递给 getNodeByKey 函数进行查找。getNodeByKey 函数为递归函数，用于查找指定 key 值所在的节点，并返回该节点的子树。
 * 这里使用了 if (node.children) 判断当前节点是否有子节点，如果有，就递归调用 getNodeByKey 函数，直到找到指定的 key 值所在的节点。
 * 最后，我们可以调用 getSubtreeByKey 函数并传入需要查找的 key 值 216，就能获取到对应的子树了。
 * @param data
 * @param key
 */
export function getSubtreeByKey(data: any[], key: number) {
	function getNodeByKey(node: any, key: number) {
		if(node) {
			if (Number(node.value) === Number(key)) {
				return node;
			}
			if (node.children) {
				for (let child of node.children) {
					const result:any = getNodeByKey(child, key);
					if (result) return result;
				}
			}
		}

		return null;
	}
	const node = data.find((item) => Number(item.value) === Number(key));
	return getNodeByKey(node, key);
}



export function setBuildSubset(arrInfo: any, field: string, pid?: number | null) {
	const ArrayData: any = [];
	if (arrInfo.length >= 1) {
		for (let item of arrInfo) {
			if (item.pid == pid) {
				let children: any = setBuildSubset(arrInfo, field, item.key);
				if (children.length >= 1) {
					item[field] = children;
				}
				ArrayData.push(item);
			}
		}
	}
	return ArrayData ?? [];
}
export function setBuildSubset22(arrInfo: any, field: string, pid?: number | null) {
	const ArrayData: any = [];
	if (arrInfo.length >= 1) {
		for (let item of arrInfo) {
			if (item.pid == pid) {
				let children: any = setBuildSubset22(arrInfo, field, item.key);
				if (children.length >= 1) {
					if (item[field] && item[field].length > 0) {
						item[field] = [...children, ...item[field]];
					} else {
						item[field] = children;
					}
				}
				ArrayData.push(item);
			}
		}
	}
	return ArrayData ?? [];
}

// 更新父节点的 disabled 属性
export function setBuildSubset3(arrInfo: any, field: string, pid?: number | null) {

	const ArrayData: any = [];

	if (arrInfo.length >= 1) {

		for (let item of arrInfo) {

			if (item.key == pid) {

				let exit: any = false;

				for (let item3 of ArrayData) {

					if (item3.key == item.key) {

						exit = true;

						break;
					}

				}

				if (!exit) {

					ArrayData.push(item);

				}

			}

			if (item.pid == pid) {

				ArrayData.push(item);

				let children: any = setBuildSubset3(arrInfo, field, item.key);

				if (children.length >= 1) {

					for (let item2 of children) {

						let exit2: any = false;

						for (let item4 of ArrayData) {

							if (item4.key == item2.key) {

								exit2 = true;

								break;
							}

						}

						if (!exit2) {

							ArrayData.push(item2);

						}
					}
				}

			}
		}
	}
	return ArrayData ?? [];
}

// 更新父节点的 disabled 属性
export function setBuildSubset4(arrInfo: any, field: string, pid?: number | null) {

	const ArrayData: any = [];

	if (arrInfo.length >= 1) {

		for (let item of arrInfo) {

			if (item.pid == pid) {

				let children: any = setBuildSubset4(arrInfo, field, item.key);

				if (children.length >= 1) {

					let exit2: any = false;

					for (let item4 of ArrayData) {

						if (item4.key == item.key) {

							exit2 = true;

							break;
						}

					}

					if (!exit2) {

						ArrayData.push(item);

					}

					for (let item2 of children) {

						let exit2: any = false;

						for (let item4 of ArrayData) {

							if (item4.key == item2.key) {

								exit2 = true;

								break;
							}

						}

						if (!exit2) {

							ArrayData.push(item2);

						}
					}

				} else {

					let exit: any = false;
					
					if (item.children != undefined && item.children && item.children.length>0) {

						exit = true;
					}

					if (exit) {

						let exit2: any = false;

						for (let item4 of ArrayData) {

							if (item4.key == item.key) {

								exit2 = true;

								break;
							}

						}

						if (!exit2) {

							ArrayData.push(item);

						}

					}

					
				}
			} else if (item.key == pid) {

				let exit: any = false;

				if (item.children != undefined && item.children && item.children.length > 0) {

					exit = true;

				}

				if (exit) {

					let exit2: any = false;

					for (let item4 of ArrayData) {

						if (item4.key == item.key) {

							exit2 = true;

							break;
						}

					}

					if (!exit2) {

						ArrayData.push(item);

					}

				}


			}

		}
	}
	return ArrayData ?? [];
}
export function setBuildSubset33(arrInfo: any, field: string, pid?: number | null) {
	const ArrayData: any = [];
	if (arrInfo.length >= 1) {
		for (let item of arrInfo) {
			if (item.pid == pid) {
				let children: any = setBuildSubset3(arrInfo, field, item.key);
				if (children.length >= 1) {
					item[field] = children;
				} else {
					item.isLeaf = true
				}
				ArrayData.push(item);
			}
		}
	}
	return ArrayData ?? [];
}

export function setBuildSubsetValue(arrInfo: any, field: string, pid?: number | null) {
	const ArrayData: any = [];
	if (arrInfo.length >= 1) {
		for (let item of arrInfo) {
			if (item.pid == pid) {
				let children: any = setBuildSubsetValue(arrInfo, field, item.value);
				if (children.length >= 1) {
					item[field] = children;
				}
				ArrayData.push(item);
			}
		}
	}
	return ArrayData ?? [];
}

export function setBuildSubset2(arrInfo: any, field: string, pid?: number | null) {
	const ArrayData: any = [];
	if (arrInfo.length >= 1) {
		for (let item of arrInfo) {
			if (item.pid == pid) {
				let children: any = setBuildSubset2(arrInfo, field, item.key);
				if (children.length >= 1) {
					item[field] = item[field].concat(children).filter((value: any, index: any, self: any) => {
						return self.indexOf(value) === index;
					});
				}
				ArrayData.push(item);
			}
		}
	}
	return ArrayData ?? [];
}

export function getBuildSubset3(arrInfo: any, field: string) {
	const ArrayData: any = [];
	if (arrInfo.length >= 1) {
		for (let item of arrInfo) {
			if (item[field] != undefined) {

				if (item[field].length >= 1) {
					let children: any = getBuildSubset3(item, field);

					for (let item2 of children) {
						ArrayData.push(item2);
					}
				}

			} else {

				ArrayData.push(item);

			}

		}
	}
	return ArrayData ?? [];
}

export function getBuildSubset34(arrInfo: any, field: string) {
	const ArrayData: any = [];
	if (arrInfo.length >= 1) {
		for (let item of arrInfo) {
			if (item[field] != undefined) {

				if (item[field].length >= 1) {
					let children: any = getBuildSubset34(item[field], field);

					for (let item2 of children) {
						ArrayData.push(item2);
					}
				}

			} else {

				ArrayData.push(item);

			}

		}
	}
	return ArrayData ?? [];
}
/**
 * 获取任务名称主
 * @return string
 * @param TaskCode
 */
export function getTaskName(TaskCode: string) {
	let TaskName: any = {
		update_layout: '更新节目',
		update_app: '更新APP',
		start_debug: '开启调试',
		stop_debug: '关闭调试',
		reg_device: '注册设备',
		sleep: '关屏',
		wake: '开屏',
		upload_device_info: '更新配置',
		del_device: '删除设备',
		reboot_device: '重启设备',
		upload_screenshot: '获取截屏',
		remove_file: '清除缓存',
		restore_factory: "恢复出厂"
	};

	return TaskName[TaskCode] ?? null;
}

/**
 * 时长换算展示
 * @param Duration
 * @constructor
 */
export function DurationChange(Duration: number) {
	let Durations: string;
	if (Duration < 60) {
		Durations = Duration + '秒';
	}

	if (Duration > 60) {
		Durations = Math.trunc(Duration / 60) + '分钟';
	}

	if (Duration > 3600) {
		Durations = Math.trunc(Duration / 60 / 60) + '小时';
	}

	// @ts-ignore
	return Durations ?? '0分钟';
}

/**
 * 时间戳转
 * @param Code
 * @constructor
 */
export function JTimeDate(Code: any) {
	let myDate = new Date(Code); //创建Date对象

	return myDate.getTime();
}
export function SecsToStr(Code: any) {
	if (Code < 3600) {
		//小于一小时
		return Math.ceil(Code / 60) + '分';
	} else {
		if (Code % 3600 == 0) {
			return Math.floor(Code / 3600) + '小时';
		} else {
			return Math.floor(Code / 3600) + '小时' + Math.ceil((Code % 3600) / 60) + '分';
		}
	}
}

export function compare(value1: any, value2: any) {
	if (value1 < value2) {
		return -1;
	} else if (value1 > value2) {
		return 1;
	} else {
		return 0;
	}
}

/**
 * 时间戳转日期
 * @param Code
 * @constructor
 */
export function JDateTime(Code: any) {
	let myDate = new Date(); //创建Date对象
	let Y = myDate.getFullYear(); //获取当前完整年份
	let M: any = myDate.getMonth() + 1; //获取当前月份
	let D: any = myDate.getDate(); //获取当前日1-31
	let H: any = myDate.getHours(); //获取当前小时
	let i: any = myDate.getMinutes(); //获取当前分钟
	let s: any = myDate.getSeconds(); //获取当前秒数
	// 月份不足10补0
	if (M < 10) {
		M = '0' + M;
	}
	// 日不足10补0
	if (D < 10) {
		D = '0' + D;
	}
	// 小时不足10补0
	if (H < 10) {
		H = '0' + H;
	}
	// 分钟不足10补0
	if (i < 10) {
		i = '0' + i;
	}
	// 秒数不足10补0
	if (s < 10) {
		s = '0' + s;
	}

	if (Code == 'Date') {
		return Y + '-' + M + '-' + D;
	}

	if (Code == 'Time') {
		return H + ':' + i + ':' + s;
	}

	if (Code == 'DateTime') {
		return Y + '-' + M + '-' + D + ' ' + H + ':' + i + ':' + s;
	}
}

/**
 * 查找值是否存在数组当中
 * @param key
 * @param value
 */
export function inArray(key: string, value: any) {
	let boolCode = false;
	if (value) {
		for (let i of value.split(',')) {
			if (key == i.toString()) {
				boolCode = true;
				break;
			}
		}
	}

	return boolCode;
}

/**
 * 处理请求接口
 * @param api
 * @param params
 */
export async function getRecords (api: any, params: any) {
	const result = await api(params);

	return result.records || [];
}

/**
 * 查找值是否存在数组当中
 * @param key
 * @param value
 */
export function inArrays(key: any, value: any) {
	let boolCode = false;
	if (value) {
		for (let i of value) {
			if (key.toString() === i.toString()) {
				boolCode = true;
				break;
			}
		}
	}

	return boolCode;
}

export function arrayCorrection(arr: any) {
	let newsArr = [];
	for (let i = 0; i < arr.length; i++) {
		if (newsArr.indexOf(arr[i]) === -1) {
			newsArr.push(arr[i]);
		}
	}
	return newsArr;
}



// 'primary'
// | 'secondary'
// | 'success'
// | 'info'
// | 'warning'
// | 'danger'
// | 'light'
// | 'dark';
export function getTaskTypeOrName(level: number, nameCode: boolean) {
	let Name: any, Type: any;
	switch (level) {
		case -1:
			Name = '已经请求';
			Type = 'info';
			break;
		case 0:
			Name = '未执行';
			Type = 'primary';
			break;
		case 1:
			Name = '执行中';
			Type = 'warning';
			break;
		case 2:
			Name = '执行成功';
			Type = 'success';
			break;
		case 3:
			Name = '执行失败';
			Type = 'dark';
			break;
		default:
			Name = '未定义';
			Type = 'dark';
			break;
	}

	return nameCode ? Name ?? '- - - -' : Type;
}

export function getNameType(level: number, nameCode?: boolean, TypeCode?: boolean) {
	let Name = null,
		Type = null;
	switch (level) {
		case 0:
			Name = '普通用户';
			Type = 'dark';
			break;
		case 1:
			Name = '一级监护';
			Type = 'dark';
			break;
		case 2:
			Name = '二级监护';
			Type = 'dark';
			break;
		case 99:
			Name = '超级管理人员';
			Type = 'dark';
			break;
	}

	return nameCode ? Name ?? '- - - -' : Type ?? null;
}

export function insertLineBreaks(str: any, every: number) {
	const regex = new RegExp(".{1," + every + "}", "g");
	return str.match(regex).join('\n\n');
}

export function JsDate(date: any, format: any) {
	const myDate: any = new Date(date * 1000);
	const year = myDate.getFullYear(); //获取当前年
	const mon =
		parseInt(myDate.getMonth()) + 1 < 10
			? '0' + parseInt(myDate.getMonth() + 1)
			: myDate.getMonth() + 1; //获取当前月

	var date =
		parseInt(myDate.getDate()) < 10 ? '0' + parseInt(myDate.getDate()) : myDate.getDate(); //获取当前日

	let h = myDate.getHours() < 10 ? '0' + parseInt(myDate.getHours()) : myDate.getHours(); //获取当前小时数(0-23)

	let m = myDate.getMinutes() < 10 ? '0' + parseInt(myDate.getMinutes()) : myDate.getMinutes(); //获取当前分钟数(0-59)

	let s = myDate.getSeconds() < 10 ? '0' + parseInt(myDate.getSeconds()) : myDate.getSeconds(); //获取当前秒

	if (format == 'date') {
		return year + '-' + mon + '-' + date;
	} else if (format == 'time') {
		return h + ':' + m;
	} else {
		return year + '-' + mon + '-' + date + ' ' + h + ':' + m;
	}
}

// 秒转 00:00:00
export function formatSeconds(value: number) {
	let h =
		Math.floor(value / 3600) < 10 ? '0' + Math.floor(value / 3600) : Math.floor(value / 3600);
	let m =
		Math.floor((value / 60) % 60) < 10
			? '0' + Math.floor((value / 60) % 60)
			: Math.floor((value / 60) % 60);
	let s = Math.floor(value % 60) < 10 ? '0' + Math.floor(value % 60) : Math.floor(value % 60);
	const result = `${h}:${m}`;
	return result;
}

/**
 *
 * @constructor
 */
export function GetTaskCondition(Condition: any) {
	const Arrays = [
		{
			key: -1,
			name: '已经请求',
		},
		{
			key: 0,
			name: '未执行',
		},
		{
			key: 1,
			name: '执行中',
		},
		{
			key: 2,
			name: '执行成功',
		},
		{
			key: 3,
			name: '执行失败',
		},
	];
	return Arrays.map((items: any) => {
		if (items.key == Condition) {
			return items.name;
		}
	});
}

/**
 * 字节数转存储
 * @param fileSize
 * @constructor
 */
export function BytesToSize(fileSize: number) {
	if (fileSize >= 1073741824) {
		// B => GB
		return (fileSize % 1073741824 === 0) ? (fileSize / 1073741824 + 'GB') : (Math.trunc(fileSize / 1073741824) + 'GB');
	} else if (fileSize >= 1048576) {
		// B => MB
		return (fileSize % 1048576 === 0)	? (fileSize / 1048576 + 'MB') : (Math.trunc(fileSize / 1048576) + 'MB');
	} else if (fileSize >= 1024) {
		// B => KB
		return (fileSize % 1024 === 0) ? (fileSize / 1024 + 'KB') : (Math.trunc(fileSize / 1024) + 'KB');
	}

	return '0KB';
}

/**
 * 输入指定长度生成随机数
 * @param len
 * @param radix
 */
export function uuid2(len: number, radix: number) {
	let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	let uuid = [];
	let i;
	radix = radix || chars.length;

	if (len) {
		// Compact form
		for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
	} else {
		// rfc4122, version 4 form
		let r;

		// rfc4122 requires these characters
		uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
		uuid[14] = '4';

		// Fill in random data.  At i==19 set the high bits of clock sequence as
		// per rfc4122, sec. 4.1.5
		for (i = 0; i < 36; i++) {
			if (!uuid[i]) {
				r = 0 | (Math.random() * 16);
				uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
			}
		}
	}

	return uuid.join('');
}


/**
 * 输入指定长度生成随机数
 * @param len
 * @param radix
 */
export function uuid2Int(len: number, radix: number) {
	let chars = '0123456789'.split('');
	let uuid = [];
	let i;
	radix = radix || chars.length;

	if (len) {
		// Compact form
		for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
	} else {
		// rfc4122, version 4 form
		let r;

		// rfc4122 requires these characters
		uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
		uuid[14] = '4';

		// Fill in random data.  At i==19 set the high bits of clock sequence as
		// per rfc4122, sec. 4.1.5
		for (i = 0; i < 36; i++) {
			if (!uuid[i]) {
				r = 0 | (Math.random() * 16);
				uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
			}
		}
	}

	return uuid.join('');
}



/**
 * 通过name获取运算符key
 * @return string
 * @param Name
 */
export function getThanOperationKey(Name: string | '>') {
	const Array: any = {
		'>': 1,
		'<': 2,
		'>=': 3,
		'<=': 4,
	};

	return Array[Name] ?? 0;
}

// 对象引用法转树形结构数据
export function arrToTreeData(data: any, key='oid', pidName = 'pid', childName = 'children') {
    // 一般 pid 就是 parentId，指的是父级 id，这里默认是 pid
    // childName 在大多数表格，多级嵌套等组件里通常都是用 children 命名，这里默认是 children
    let obj: any = {} // 初始化
    let result = [] // 初始化

    // 将数据以对象的格式先存起来
    data.forEach((item: any) => {
        obj[item[key]] = item
    })

    for (let i = 0; i < data.length; i++) {
        let item = data[i]
        // 这里去 obj 里找，如果没有找到那就是 undefined，说明这个当前 item 是根节点
        let parent = obj[item[pidName]]
        if (parent) {
            (parent[childName] || (parent[childName] = [])).push(item)
        } else {
            result.push(item)
        }
    }

    return result
}

// 将 URL 地址末尾统一为带斜杠的格式
export function addSlash(str:string) {
	if(!str) return str
	if (str.endsWith('/')) {
	  return str;
	} else {
	  return str + '/';
	}
  }